export { default as ScalarWrappingText } from "./ScalarWrappingText.vue.js";
